<template>
    <div @click="$emit('selected')"> 
        <svg width="74" height="38" viewBox="0 0 74 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3H71V35H3V3Z" fill="#CACACA" fill-opacity="0.1"/>
            <line x1="0.5" y1="8" x2="0.5" y2="2.18556e-08" stroke="#CACACA"/>
            <line x1="1" y1="0.5" x2="8" y2="0.5" stroke="#CACACA"/>
            <line x1="66" y1="0.5" x2="74" y2="0.5" stroke="#CACACA"/>
            <line x1="73.5" y1="1" x2="73.5" y2="8" stroke="#CACACA"/>
            <line x1="8" y1="37.5" x2="4.37113e-08" y2="37.5" stroke="#CACACA"/>
            <line x1="0.5" y1="37" x2="0.5" y2="30" stroke="#CACACA"/>
            <line x1="73.5" y1="30" x2="73.5" y2="38" stroke="#CACACA"/>
            <line x1="73" y1="37.5" x2="66" y2="37.5" stroke="#CACACA"/>
            <path v-if="select" d="M28 16L36.2929 24.2929C36.6262 24.6262 36.7929 24.7929 37 24.7929C37.2071 24.7929 37.3738 24.6262 37.7071 24.2929L46 16" stroke="#CACACA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>
<script>
export default {
    name: "UzhnetSelect",

    props: {
        select: {
            type: Boolean,
            default: false
        }
    },

    emits: ['selected']
}
</script>
<style lang="scss"></style>